var _rect, _rect2, _rect3, _text, _text2, _text3, _circle, _circle2, _circle3, _circle4, _circle5, _rect4, _text4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpicerouteKitchen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 750",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 750,
    fill: "#441514"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 1060,
    height: 610,
    rx: 26,
    fill: "#fff5df"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 1060,
    height: 82,
    rx: 26,
    fill: "#b83d26"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 122,
    fontFamily: "Arial",
    fontSize: 28,
    fontWeight: 700,
    fill: "#fff"
  }, "SPICEROUTE KITCHEN")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 260,
    fontFamily: "Georgia",
    fontSize: 62,
    fontWeight: 700,
    fill: "#471916"
  }, "Flavours with a story.")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 310,
    fontFamily: "Arial",
    fontSize: 23,
    fill: "#81635d"
  }, "A modern table inspired by the road.")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 900,
    cy: 405,
    r: 148,
    fill: "#f1c56d"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 900,
    cy: 405,
    r: 102,
    fill: "#b83d26"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 900,
    cy: 405,
    r: 65,
    fill: "#f4df9a"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 870,
    cy: 380,
    r: 10,
    fill: "#b83d26"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 930,
    cy: 430,
    r: 10,
    fill: "#b83d26"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 420,
    width: 260,
    height: 64,
    rx: 32,
    fill: "#2b6d50"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 460,
    fontFamily: "Arial",
    fontSize: 20,
    fontWeight: 700,
    fill: "#fff"
  }, "See the menu")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 545,
    width: 200,
    height: 55,
    rx: 12,
    fill: "#f5dfb6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 545,
    width: 200,
    height: 55,
    rx: 12,
    fill: "#f5dfb6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpicerouteKitchen);
export default __webpack_public_path__ + "static/media/spiceroute-kitchen.23c12c3ebdd881d6391371aa95bdbc9b.svg";
export { ForwardRef as ReactComponent };